export const getAustriaData = () => ({
  name: "Autriche",
  description: "L'Autriche est un pays viticole traditionnel avec une histoire millénaire, produisant des vins blancs élégants et des vins rouges de qualité. Le pays est réputé pour ses vins secs et ses vins liquoreux exceptionnels, notamment dans la région de Burgenland.",
  type: "country",
  regions: [
    { name: "Niederösterreich", area: "28,000 ha", percentage: "65%", description: "Plus grande région" },
    { name: "Burgenland", area: "12,000 ha", percentage: "28%", description: "Vins liquoreux" },
    { name: "Steiermark", area: "2,500 ha", percentage: "6%", description: "Vins blancs" },
    { name: "Wien", area: "600 ha", percentage: "1%", description: "Vins urbains" }
  ],
  mapAreas: [
    { region: "Niederösterreich", x: 16.0, y: 48.5, color: "#4B164C", size: 7 },
    { region: "Burgenland", x: 16.5, y: 47.8, color: "#6d2c7a", size: 5 },
    { region: "Steiermark", x: 15.5, y: 47.0, color: "#8a4a8a", size: 3 },
    { region: "Wien", x: 16.4, y: 48.2, color: "#a768a6", size: 2 }
  ],
  statistics: {
    totalArea: "43,100 ha",
    production: "2.5 million hectolitres",
    regions: "4 régions principales",
    appellations: "20+ appellations",
    exportPercentage: "15%"
  },
  characteristics: {
    climate: "Climat continental avec influences alpines, étés chauds et hivers froids",
    soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges élégants et structurés, avec des tanins fins et une belle acidité",
    white: "Vins blancs secs et aromatiques, avec une acidité vive et des notes minérales",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sweet: "Vins liquoreux exceptionnels, notamment les Beerenauslese et Trockenbeerenauslese"
  },
  history: "La viticulture autrichienne remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. L'Autriche a une tradition viticole millénaire, avec des cépages autochtones comme le Grüner Veltliner. Aujourd'hui, l'Autriche est reconnue pour ses vins blancs de qualité et ses vins liquoreux prestigieux.",
  foodPairing: "Cuisine autrichienne traditionnelle : Wiener Schnitzel, Tafelspitz, Apfelstrudel, fromages affinés. Les vins autrichiens s'accordent parfaitement avec la cuisine locale et les plats internationaux."
}); 